import {OkDocument} from "../resources/common"

export const mergeResults = <T>(result1?: OkDocument<T[]>, result2?: OkDocument<T[]>): OkDocument<T[]> => {
	const included = [...(result1?.included || []), ...(result2?.included || [])]
	const data = [...(result1?.data || []), ...(result2?.data || [])]
	const meta = result2?.meta
	return {included, data, meta}
}
